import { render, staticRenderFns } from "./selectbox.vue?vue&type=template&id=2b496a6c&"
import script from "./selectbox.vue?vue&type=script&lang=js&"
export * from "./selectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports